import React from "react";
import styles from "./style.module.css";
import PlanCard from "../PlanCard";

const Pricing = () => {
  const plans = [
    {
      title: "Paying Guests/ Co-living/ Hostel ",
      description:
        "Transparent Pricing Options for Paying Guests, Co-living Communities, and Hostel Operators",
      monthlyCharge: "₹50",
      smallDesc: "For one Bed",
      features: [
        "Complete product suite",
        "Automated finances and management",
        "Platform demo by our team",
        "24/7 Technical support",
      ],
    },
    {
      title: "Individual House/ Flats/ Apartments",
      description:
        "Flexible Pricing Solutions for Individual houses, flats, and Apartments owners",
      monthlyCharge: "₹100",
      smallDesc: "For one Flat",
      features: [
        "Complete product suite",
        "Automated finances and management",
        "Platform demo by our team",
        "24/7 Technical support",
      ],
    },
  ];
  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        <h5 className={styles.header}>Pricing</h5>
        <h3 className={styles.subHeading}>
          Supercharge your business growth by 5x while  maintaining
          minimal platform costs
        </h3>
      </div>
      <div className={styles.planCardContainer}>
        {plans.map((plan, index) => (
          <PlanCard
            key={index}
            title={plan.title}
            description={plan.description}
            monthlyCharge={plan.monthlyCharge}
            features={plan.features}
            smallDesc={plan.smallDesc}
          />
        ))}
      </div>
    </div>
  );
};

export default Pricing;
